function createResizeObserver(callback: ResizeObserverCallback): ResizeObserver {
  if(typeof ResizeObserver !== 'undefined') {
    return new ResizeObserver(callback);
  }

  return {
    observe: () => {},
    unobserve: () => {},
    disconnect: () => {}
  } as ResizeObserver;
}

const resizeObserverMap: WeakMap<Element, (entry: ResizeObserverEntry) => void> = new WeakMap();
const resizeObserver = createResizeObserver((entries) => {
  for(const entry of entries) {
    const callback = resizeObserverMap.get(entry.target);
    callback(entry);
  }
});

export function observeResize(element: Element, callback: (entry: ResizeObserverEntry) => void) {
  resizeObserverMap.set(element, callback);
  resizeObserver.observe(element);

  return () => {
    unobserveResize(element);
  };
}

export function unobserveResize(element: Element) {
  resizeObserverMap.delete(element);
  resizeObserver.unobserve(element);
}
